import React, {Component} from "react";
import {GdAutocomplete, StateOptions, Input, Button} from "gd-react";
import GridDuck from 'gridduck';
import DeviceForm from "../../components/DeviceForm";
import BLE_PULSE_DELIVERED from "../../images/products/BLE_PULSE_DELIVERED.png";
import SEN_TEM_PROBE from "../../images/products/SEN-TEM-PROBE.png";
import REL_DIN_32A_OWON from "../../images/products/REL-DIN-32A-OWON.png";
import INL_SWI from "../../images/products/INL-SWI.png";
import MET_REA from "../../images/products/MET-REA.png";
import SEN_TEM_HUM from "../../images/products/SEN-TEM-HUM.png";
import SEN_LIGHT_MOTION from "../../images/products/SEN-LIGHT-MOTION.png";
import NB_IOT_PULSE_DELIVERED from "../../images/products/NB-IOT-PULSE_DELIVERED.png";
import BACNET_IP from "../../images/products/BACNET_IP.png";
// Load in all product images
const images = require.context('../../images/products', false, /\.png$/);
const imageMap = {};
const gatewayDeviceLimit = 17;

images.keys().forEach((key) => {
    const filename = key.replace('./', '').replace('.png', '');
    imageMap[filename] = images(key);
});

class AddPhysicalDevice extends Component {

    constructor(props) {
        super(props);
        this.errors = {};
        ['checkExistingAssets', 'formatMacAddress', 'handleMac', 'getHubShortcuts', 'selectDevice', 'getHubs', 'selectHub', 'setFooter', 'handleNext', 'navBack'].forEach(func => this[func] = this[func].bind(this));
        const deviceTypes = StateOptions.filter(so => !so.hiddenFromDashAddDevice);
        this.state = {
            deviceTypes: deviceTypes,
            site: {id: this.props.siteId},
            sites: [],
            noHubs: false,
            errorMessage: '',
            mac: '',
            manualHub: null,
            triedToSave: false,
            addingSingleAsset: null,
            dataType: null,
            devices: [],
            existingList: [],
            deviceType: null,
            fixedCategorys: [],
            page: 1,
            loaded: false
        }
        this.formRef = React.createRef();
    }

    navBack() {
        let page = this.state.page += -1;
        this.setState({page: page})
    }

    async checkExistingAssets() {
        let self = this
        let code = this.state.mac;
        let noWhitespaceCode = code.split(' ').join('')
        let filters = [
            {
                field: 'code',
                value: noWhitespaceCode
            }
        ]
        let assetsRes = await GridDuck.getAssets({filters: filters})
        let assetList = assetsRes.list;

        if ((assetList.length > 0) && (assetList[0].sku)) {
            let deviceType = self.state.deviceTypes.find((d) => assetList[0].sku.includes(d.type));
            self.setState({existingList: assetList})
            if (assetList.length >= deviceType.maxInstances) {
                self.setState({errorMessage: `Device ${noWhitespaceCode} already exists, choose another device to install`})
                return Promise.reject('Already Exists')
            }
            return Promise.resolve()
        }
        return Promise.resolve()
    }

    async handleNext(e) {
        let self = this
        this.setState({triedToSave: true, loaded: false});
        if (Object.values(this.errors).length && Object.values(this.errors).find((e) => e === true)) return new Promise(function (resolve, reject) {
            self.setState({loaded: true})
            return reject();
        })
        if (this.state.deviceType.macLength) await self.checkExistingAssets();

        let asset = {
            sku: this.state.deviceType.sku,
            deviceType: this.state.deviceType,
            children: this.state.devices,
            assetCode: this.state.mac.split(' ').join('').toUpperCase(),
        }
        if (self.state.deviceType && self.state.deviceType.hubRequired) {
            asset.gatewayId = this.state.manualHub.id
        }
        self.setState({
            loaded: true,
            addingSingleAsset: asset,
            page: 2
        }, () => {
            this.props.updateFooter(self.setFooter());
        })
        return Promise.resolve()
    }

    setFooter() {
        let self = this;
        let footer = [];
        if (this.state.page === 1) {
            footer.push((
                <div className={'button-container'}>
                    <Button
                        key={'next-butt'}
                        onClick={self.handleNext}
                        progressRes
                        label={"Next"}
                        color={"gd-brand"}
                    />
                </div>));
            footer.push((
                <div className={'button-container'}>
                    <Button
                        onClick={() => {
                            self.setState({
                                page: 1,
                                mac: '',
                                dataType: null,
                                manualHub: null,
                                deviceType: null,
                                site: null,
                                triedToSave: false
                            }, () => {
                                this.props.backToTypeSelection();
                            })
                        }}
                        label={"Back"}
                        outline
                        color={"gd-grey"}
                    />
                </div>
            ))

        } else if (this.state.page === 2) {
            footer.push((
                <div className={'button-container'}>
                    <Button
                        key={'submit-butt'}
                        // additionalclasses={'sm left'}
                        onClick={this.formRef.current.submitAsset}
                        progressRes={true}
                        label={"Add Device"}
                        color={"gd-green"}
                    />
                </div>))
            footer.push((
                <div className={'button-container'}>
                    <Button
                        onClick={() => {
                            this.formRef.current.clearFields();
                            this.setState({
                                page: 1,
                                addingSingleAsset: null,
                                mac: '',
                                deviceType: null,
                                triedToSave: false
                            }, () => {
                                this.props.updateFooter(self.setFooter());
                            })
                        }}
                        label={"Back"}
                        outline
                        color={"gd-grey"}
                    />
                </div>
            ))
        }
        return footer;
    }

    formatMacAddress(userInput) {
        if (userInput) {
            return userInput.replace(/[^A-Fa-f0-9]/g, "").replace(/(.{4})/g, '$1 ').trim().toUpperCase();
        } else return '';
    }

    handleMac(input) {
        let inputText = this.formatMacAddress(input.target.value);
        this.setState({
            mac: inputText,
            errorMessage: '',
            triedToSave: false
        });
    }

    componentDidMount() {
        this.props.updateFooter(this.setFooter());
    }

    async selectHub(input, obj) {
        let self = this;
        if (!obj || !obj.id) {
            self.errors['hubLength'] = false;
            self.setState({manualHub: null});
        }
        let promises = []
        promises.push(GridDuck.getAssets({
            filters: [
                {
                    field: 'gatewayId',
                    value: obj?.id
                }
            ]
        }))

        if (obj) {
            let item = {
                itemType: 'gateway',
                itemId: obj.id
            };
            promises.push(GridDuck.createSearchHistory(item))
        }
        let res = await Promise.all(promises);
        let assets = res[0].list.length;
        self.errors['hubLength'] = (assets >= gatewayDeviceLimit);
        self.setState({manualHub: obj});
    }

    async getHubShortcuts() {
        let site = this.state.site;

        let promises = []

        promises.push(GridDuck.getSearchHistorys({
            filters: [
                {
                    field: 'itemType',
                    value: 'gateway'
                }
            ]
        }))

        if (site) {
            let filters = [
                {
                    field: "siteId", value: site.id,
                },
                {
                    field: "locationId", value: site.locationId,
                },
            ];
            promises.push(GridDuck.getGateways({
                filters: filters
            }))
        }

        let lists = await Promise.all(promises)

        let searches = lists[0].list.map((r) => {
            return {
                id: r.itemId,
                title: r.name,
                subtitle: r.metadata.locationName,
                icon: 'GiAnticlockwiseRotation',
                type: 'Recent'
            }
        })

        let suggested = []

        if (site && site.locationId) {
            suggested = lists[1]?.list.map((s) => {
                return {
                    id: s.id,
                    title: s.name,
                    subtitle: s.locationName,
                    icon: 'FaAtom',
                    type: 'Suggested'
                }
            })
        }

        let shortcuts = suggested.concat(searches)

        this.setState({hubShortcuts: shortcuts})
    }

    async getHubs(searchTerm, reset) {

        let self = this
        if (reset) self.hubOffset = 0
        let filters = []
        let limit = 25
        if (searchTerm) filters.push({
            field: 'search',
            value: searchTerm
        })
        let res = await GridDuck.getGateways({filters: filters, offset: this.hubOffset,})
        let hubs = res.list
            .filter(s => s._permission === 'admin')
            .map(
                s => ({
                    id: s.id,
                    title: s.name,
                    subtitle: s.locationName ? s.locationName : '',
                    icon: 'FaSquare',
                })
            );
        let newOffset = self.hubOffset + limit;
        self.hubOffset = newOffset
        return Promise.resolve(hubs)
    }

    checkErrors() {
        let errors = {};
        let page = this.state.page
        if (page === 1) {
            let noWhiteSpace = this.state.mac?.split(' ').join('');
            if (this.state.deviceType?.macLength && (!this.state.mac || this.state.deviceType.macLength !== noWhiteSpace.length)) {
                errors['mac'] = true;
            }
            if (!this.state.deviceType) {
                errors['deviceType'] = true;
            }
            if (this.state.deviceType && this.state.deviceType.hubRequired && !this.state.manualHub) {
                errors['manualHub'] = true;
            }
        }
        this.errors = errors
    }

    selectDevice(device, deviceObj) {
        this.setState({deviceType: deviceObj, triedToSave: false});
    }

    render() {
        this.checkErrors();
        return <div className={'form-container'}>
            {this.state.page === 1 && <div>
                <div className={'row'}>
                    <GdAutocomplete
                        grid
                        image
                        name={'device-type'}
                        error={this.errors['deviceType'] && this.state.triedToSave}
                        value={this.state.deviceType}
                        placeholder={'Search for a Device'}
                        options={this.state.deviceTypes.map((t) => {
                            const image = imageMap[t.type]?.default || imageMap[t.type?.replace(/_[^_]+$/, '')]?.default || imageMap['unknown']?.default;

                            return {
                                title: t.label,
                                sku: t.type,
                                hubRequired: !t.noHub,
                                macLength: t.macLength,
                                value: t.id,
                                image: image,
                            }
                        })}
                        onChange={this.selectDevice}
                        label="Device Type"/>
                </div>
                {this.state.deviceType && this.state.deviceType.macLength ?
                    <div className={'row'} style={{marginTop: '20px'}}>
                        <Input
                            required
                            error={this.errors['mac'] && this.state.triedToSave}
                            maxLength={19}
                            top="true"
                            label={'MAC Address'}
                            name={'mac'}
                            onChange={this.handleMac}
                            value={this.state.mac}
                        />
                    </div> : null}
                {this.state.errorMessage ? <div className={'row'} style={{marginTop: '20px'}}>
                    <p className={'error-text'}>
                        {this.state.errorMessage}
                    </p>
                </div> : null}
                {this.state.deviceType && this.state.deviceType.hubRequired ?
                    <div className={'row'} style={{marginTop: '20px'}}>
                        <GdAutocomplete
                            async
                            icon
                            subtitle
                            lazyload
                            clearOffset={() => {
                            }}
                            getShortcuts={this.getHubShortcuts}
                            shortcuts={this.state.hubShortcuts}
                            name={'hub'}
                            getOptionSelected={function (option, value) {
                                if (option && value) return option.id === value.id;
                            }}
                            error={(this.errors['hubLength'] || this.errors['manualHub']) && this.state.triedToSave}
                            value={this.state.manualHub}
                            placeholder={'Select a hub'}
                            getList={this.getHubs}
                            onChange={this.selectHub}
                            label="Hub"/>
                    </div> : null}
            </div>}
            {this.state.page === 2 && <div>
                <DeviceForm
                    existingList={this.state.existingList}
                    ref={this.formRef}
                    hubs={this.state.hubs}
                    site={this.state.site}
                    asset={this.state.addingSingleAsset}
                    closeForm={this.props.closeModal}
                />
            </div>}
        </div>
    }
}

export default AddPhysicalDevice;